<app-pick-services (pickSlotActive)="setPickSlotActive($event)" [real]="real"
></app-pick-services>

<!-- O SALONU START -->
<div class="ion-padding about-saloon" style="padding-top:0px;">
  <h3 class="about-saloon__title">{{ 'SHOP_DETAIL.ABOUT' | translate }}</h3>

  <div class="about-saloon__desc expanded" style="white-space:pre-wrap;"> 
    <p class="formatted" [innerHtml]="real?.longDescription | ppTranslate:real?.longDescriptionTranslations:translateService.currentLang"></p>
    <!--<a class="dropdown-text">PREBERI VEČ
    <ion-icon class="dropdown"></ion-icon>
    </a>-->
  </div>

  <div class="about-saloon__info">
    <h5><span *ngIf="real?.provider.brandName !== real?.name && real?.provider.slug !== 'jezersek'">{{ real?.provider.brandName }} </span>{{ real?.name }}</h5>
    <p>{{ real?.address }}</p>
  </div>


  <div *ngIf="real?.freeParking || real?.parkingInfo" class="about-saloon__parking">

    <p>
      <ion-icon style="font-size: 27px !important;" name="car" mode="md"></ion-icon>
      <span *ngIf="real?.freeParking">{{ 'SHOP_DETAIL.FREE_PARKING' | translate }}</span>
      <span *ngIf="!real?.freeParking">{{ 'SHOP_DETAIL.PARKING' | translate }}</span>
    </p>
    
    <p>{{ real?.parkingInfo }}</p>

  </div>


  <div class="about-saloon__contact">

    <p>
      <a [href]="'tel:' + real?.phone1" style="text-decoration: none;">
      <ion-icon  name="call" mode="md"></ion-icon><span *ngIf="translateService.currentLang !== 'sl'">{{ real?.phone1 || '' | internationalFormat : 'SI' }}</span><span *ngIf="translateService.currentLang == 'sl'">{{ real?.phone1 || '' | nationalFormat : 'SI' }}</span></a>
    </p>

    <p>
      <a [href]="'mailto:' + ( real?.email ? real?.email: real?.provider.email )" style="text-decoration: none;">
      <ion-icon  name="mail" mode="md"></ion-icon>{{ ( real?.email ? real?.email: real?.provider.email ) }}</a>
    </p>


    <p>
      <a *ngIf="real?.website" [href]="((real?.website.substr(0,4) === 'http')?'':'https://') + real?.website" target="_blank" style="text-decoration: none;">
      <ion-icon  name="globe-outline" mode="md"></ion-icon></a>

      <a *ngIf="real?.instagram" [href]="'https://instagram.com/' + real?.instagram + '/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-instagram" mode="md"></ion-icon></a>

      <a *ngIf="real?.facebook" [href]="'https://facebook.com/' + real?.facebook +'/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-facebook" mode="md"></ion-icon></a>
    </p>

    <p *ngIf="false && real?.website">
      <a [href]="((real?.website.substr(0,4) === 'http')?'':'https://') + real?.website" target="_blank" style="text-decoration: none;">
      <ion-icon  name="globe-outline" mode="md"></ion-icon>{{ real?.website }}</a>
    </p>

    <p *ngIf="false && real?.instagram">
      <a [href]="'https://instagram.com/' + real?.instagram + '/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-instagram" mode="md"></ion-icon>{{ real?.instagram }}</a>
    </p>

    <p *ngIf="false &&  real?.facebook">
      <a [href]="'https://facebook.com/' + real?.facebook +'/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-facebook" mode="md"></ion-icon>{{ real?.facebook }}</a>
    </p>


    <p *ngIf="real?.googleMaps">
      <a [href]="'https://maps.app.goo.gl/' + real?.googleMaps" target="_blank" style="text-decoration: underline; text-decoration-style: dotted;">
      <ion-icon class="google-maps" style="font-size:20px"></ion-icon>{{ 'SHOP_DETAIL.GOOGLE_MAPS_LINK' | translate }}</a>
    </p>

  </div>


</div>

<div class="about-saloon__map-holder">
    <!-- Map instead of img -->
    <agm-map [scrollwheel]="false" [gestureHandling]="'cooperative'" [zoom]="13" [latitude]="real?.geoPoint?.coordinates[1]" [longitude]="real?.geoPoint?.coordinates[0]">
      <agm-marker [latitude]="real?.geoPoint?.coordinates[1]" [longitude]="real?.geoPoint?.coordinates[0]"></agm-marker>
    </agm-map>
    <!--<ion-img src="https://spletnik.si/blog/wp-content/uploads/2012/09/spletnik_zemljevid.png"></ion-img>-->
  </div>
<!-- O SALONU END -->

<div class="opening-hours ion-padding" *ngIf="open$ | async as open">

  <ng-container *ngIf="open.executionTimeRange?.commands?.length > 0 && !real?.openingHours">
  
  <p class="opening-hours__heading">{{ 'SHOP_DETAIL.OPENING_HOURS' | translate }}</p>

  <p *ngFor="let command of open.executionTimeRange?.commands | myFilter: filterCommand" class="opening-hours__item">{{ displayOpeningHoursDays( command.weeklyDays, command.absoluteIntervals, command.validForHolidaysArr, translateService.currentLang) }}<span *ngIf="!command.excepted" class="ion-float-right">
  {{ displayHours(command.dailyIntervals) }}
  </span><span *ngIf="command.excepted" class="ion-float-right">
  {{ 'SHOP_DETAIL.CLOSED' | translate }}
  </span></p>

  <!--p *ngIf="real?.openingHours" class="formatted opening-hours__item" [innerHtml]="real?.openingHours | ppTranslate:real?.openingHoursTranslations:translateService.currentLang"></p-->


  </ng-container>


  <ng-container *ngIf="real?.openingHours">
  
  <p class="opening-hours__heading">{{ 'SHOP_DETAIL.OPENING_HOURS' | translate }}</p>

  <p *ngIf="real?.openingHours" class="formatted opening-hours__item" [innerHtml]="real?.openingHours | ppTranslate:real?.openingHoursTranslations:translateService.currentLang"></p>

  </ng-container>

  <!---<p class="opening-hours__item">Sob <span class="ion-float-right">7.00 - 14.00</span></p>-->
</div>

<!-- TEAM SECTION START -->
<ion-grid  class="ion-padding"  style="margin-top:0px; " *ngIf="real?.slug !== 'castle-restaurant-taggenbrunn'">
  <ion-row style="margin-bottom:5px;">
    <ion-col *ngIf="real.provider.employees.length > 0">
      <h3 class="team">{{ 'SHOP_DETAIL.TEAM' | translate }}</h3>
    </ion-col>
  </ion-row>
  <ion-row class="team-showcase">
    <ng-container *ngFor="let employee of real.provider.employees">
      <ion-col (click)="openEmployeeModal(employee)" size="4" class="clickable team-showcase__item" *ngIf="real.provider.slug !== 'jezersek' || !employee.email || employee.email == real.slug + '@jezersek.si'">
        <img [src]="employee?.avatar?.document?.fileName | ppImage">
        <p>
          <a class="pp-link">{{ employee.name }}</a>
        </p>
        <span>{{ employee.shortDescription | ppTranslate:employee?.shortDescriptionTranslations:translateService.currentLang }}</span>
      </ion-col>
    </ng-container>
  </ion-row>
  
</ion-grid>
<!-- TEAM SECTION END -->